import RegularChart from '@/features/charts/RegularChart';
import type {
  ChartType,
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/features/charts/types/highcharts';

import ChartLegend from './ChartLegend';

interface AuthenticatedChartProps {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  error: boolean;
  loading: boolean;
  chartOptions: ExtendedOptions | undefined;
  chartType: ChartType | undefined;
}

const AuthenticatedChart = ({
  chartSeries,
  error,
  loading,
  chartOptions,
  chartType
}: AuthenticatedChartProps) => (
  <>
    <RegularChart
      chartSeries={chartSeries}
      chartType={chartType}
      error={error}
      loading={loading}
      options={chartOptions}
      showLegend={false}
    />
    <ChartLegend series={chartOptions?.series} />
  </>
);

export default AuthenticatedChart;
